<template>
  <div class="item-inner">
    <div class="item-title label" v-if="attribute.sorteditAble === false" style="width: 60%;color: #8e8e93">{{this.attribute.label}}</div>
    <div class="item-title label" style="width: 60%" v-else>{{this.attribute.label}}</div>
    <div class="item-input">
      <input  type="text" placeholder="请填写"  style="font-size: .6rem;text-align: right; " v-if="attribute.sorteditAble === false || attribute.groupId === 1" readonly="readonly"  :value='attribute.valueText'>
      <input type="text"     placeholder="实际所得靶点数量" style="font-size: .6rem;text-align: right; "  v-else-if="attribute.sorteditAble === true && attribute.columnName === 'TargetNum' "  v-model="attribute.value" >
      <input type="text"     placeholder="选填"   style="font-size: .6rem;text-align: right; " v-else-if="attribute.sorteditAble === true && attribute.columnName === 'TvNoNumber' "  v-model="attribute.value" >
      <input type="text"   placeholder="必填"  style="font-size: .6rem;text-align: right; " v-else   v-model="attribute.value" >
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  export default {
    name: 'finder-attr-number-box',
    data () {
      return {
      }
    },
    props: [
      'attribute', 'index', 'curAttrsInGroup'
    ],
    mounted () {
    },
    created () {
    },
    computed: {
    },
    methods: {
    },
    watch: {
      'attribute.value': function (val) {
        if (val !== '') {
          if (val.replace(/[^\d]/g, '') === '') {
            alert('请您填写数字')
          }
        }
        if (this.attribute.columnName === 'PlasmidNumber' && val > 1) {
          var _this = this
          $.modal({
            title: '请核对',
            afterText: '<div>请确认客户所提供的质粒抗性都相同，否则不同抗性的质粒请单独录入订单合同。</div>',
            buttons: [
              {
                text: '不确定',
                bold: true,
                onClick: function () {
                  alert('请您重新选择！')
                }
              },
              {
                text: '确定',
                bold: true,
                onClick: function () {
                  _this.attribute.valueText = val
                  _this.$emit('controlForm', _this.index, _this.curAttrsInGroup, _this.attribute)
                }
              }
            ]
          })
        } else {
          this.$emit('controlForm', this.index, this.curAttrsInGroup, this.attribute)
        }
      }
    }
  }
</script>

<style scoped>
  input {
    border: 1px solid #ccc;
    outline: 0;
    transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  }
  .error input {
    border-color: rgba(246, 58, 56, .8);
    box-shadow: 0 0 8px rgba(246, 58, 56, .6);
  }
  .item-title {
    font-size: 0.6rem;
    color: black;
  }
  .guding {
    width: 140px;
  }
  .item-after {
    font-size: 0.6rem;
    color: black;
  }
</style>



// WEBPACK FOOTER //
// FinderAttrNumberBox.vue?50697476